<main class="c-main" role="main">
    <div class="c-page-other2confirm">
      <div class="container">
        <div class="row mobile--orange u-pt30 u-pb30">
          <div class="col-md-12">
            <!-- <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="js-txt1" href="#">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">-  </li><span class="js-txt2">Site Access Approver</span>
              </ol>
            </nav> -->
            <h2 class="o-title js-txt3">{{'MedicalConfirmationPublic.title' | translate}}</h2>
          </div>
        </div>
      </div>
      <section class="c-results">
        <div class="container u-pt40 u-pb60">
          <div class="row">


            <div class="col-md-10 col-md-offset-1" *ngIf="success==='success' &&  ((medicalTest == '2') || (medicalTest=='3'))">
              <h2 class="o-title o-title--medium o-title--center js-txt4">{{'MedicalConfirmationPublic.body' | translate}}</h2>
              <div class="o-steps">
                <div class="row">
                  <div class="col-md-10 col-md-offset-1">
                    <div class="row">
                      <div class="col-md-12" style="padding: 5px !important; text-align: center;" *ngIf="success==='success'" > 
                        <hr class="big">
                        <h2 class="o-title o-title--medium o-title--orange">{{'MedicalConfirmationPublic.statusMedical' | translate}}: 
                          <i *ngIf="medicalTest=='3'" class="icon icon-close" style="text-align: center;"> </i>
                          <i *ngIf="medicalTest=='2'" class="icon icon-check" style="text-align: center;"> </i>
                        </h2>
                        <p *ngIf="medicalTest=='3'" >{{'MedicalConfirmationPublic.medicalRejected' | translate}}</p>
                        <p *ngIf="medicalTest=='2'" >{{'MedicalConfirmationPublic.medicalApproved' | translate}}</p>
                        <hr class="big">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             <!-- <p class="o-text o-text--big u-pb30 center"> <span class="js-txt5">In case of any questions contact your Host: </span><a href="mailto:mail@mail.com">Lalo Landa</a></p>-->
            </div>

            <div class="col-md-10 col-md-offset-1" *ngIf="success==='fail' || ((medicalTest != '2') &&(medicalTest!='3')) ">
              <h2 class="o-title o-title--medium o-title--center js-txt4">{{'MedicalConfirmationPublic.requestFailed' | translate}} Your access request has failed</h2>
              <div class="o-steps">
                <div class="row">
                  <div class="col-md-10 col-md-offset-1">
                    <div class="row">
                      <div  class="col-xs-6 col-xs-offset-3 o-steps__step o-steps__step--rejected">
                        <div  class="o-steps__circle"><i class="icon icon-close"></i></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             <!-- <p class="o-text o-text--big u-pb30 center"> <span class="js-txt5">In case of any questions contact your Host: </span><a href="mailto:mail@mail.com">Lalo Landa</a></p>-->
            </div>
          </div>
        </div>
      </section>
      
      <!-- <div class="col-md-12" style="padding: 5px !important; text-align: center;" *ngIf="success==='success'" > 
        <hr class="big">
        <h2 class="o-title o-title--medium o-title--orange">Status Medical: 
          <i *ngIf="medicalTest=='3'" class="icon icon-close" style="text-align: center;"> </i>
          <i *ngIf="medicalTest=='2'" class="icon icon-check" style="text-align: center;"> </i>
        </h2>
        <p *ngIf="medicalTest=='3'" >The medical tests have been rejected</p>
        <p *ngIf="medicalTest=='2'" >The medical exams have been approved</p>
        <hr class="big">
      </div> -->
     
    </div>

  </main>